module.exports = "/images/resource-image-contract.png?d994f12a32d9b2bf768b86d0523542eb";